import React from "react";

export const OtherLocationIcon = ({
  width = 16,
  height = 16,
  color1 = "#000000",
  className = "",
  cursor = "pointer",
  style = {},
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    className={className}
    cursor={cursor}
    fill="none"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 0.666748C4.6924 0.666748 2 3.35915 2 6.66675C2 8.98769 3.48025 10.9427 4.90234 12.323C6.32444 13.7033 7.74609 14.5391 7.74609 14.5391L8 14.6876L8.25391 14.5391C8.25391 14.5391 9.67556 13.7033 11.0977 12.323C12.5197 10.9427 14 8.98769 14 6.66675C14 3.35915 11.3076 0.666748 8 0.666748ZM8 5.00008C8.59722 5.00008 8.98183 5.20604 9.2513 5.5092C9.52078 5.81235 9.66667 6.23619 9.66667 6.66675C9.66667 7.0973 9.52078 7.52114 9.2513 7.8243C8.98183 8.12746 8.59722 8.33341 8 8.33341C7.40278 8.33341 7.01817 8.12746 6.7487 7.8243C6.47922 7.52114 6.33333 7.0973 6.33333 6.66675C6.33333 6.23619 6.47922 5.81235 6.7487 5.5092C7.01817 5.20604 7.40278 5.00008 8 5.00008Z"
      fill={color1}
    />
  </svg>
);

export default OtherLocationIcon;
